<template>
  <v-container fluid>
    <v-card>
      <v-card-title class="text-h5 pa-4">
        <v-icon :icon="mdiChartLine" class="mr-2"></v-icon>
        {{ $t("projections.title") }}
      </v-card-title>

      <v-card-text>
        <v-alert
          v-if="error"
          type="error"
          variant="tonal"
          closable
          class="mb-4"
          @click:close="clearError"
        >
          {{ error }}
        </v-alert>

        <v-data-table
          :headers="headers"
          :items="eligibleCustomers"
          :loading="loading"
          :search="search"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-text-field
                v-model="search"
                density="compact"
                :label="$t('search')"
                class="pl-2"
                :prepend-inner-icon="mdiMagnify"
                variant="solo-filled"
                flat
                hide-details
                single-line
              ></v-text-field>
            </v-toolbar>
          </template>

          <template v-slot:item.hasSalesHistory="{ item }">
            <v-chip :color="item.hasSalesHistory ? 'success' : 'warning'" small>
              <v-icon
                :icon="item.hasSalesHistory ? mdiCheckCircle : mdiAlertCircle"
                size="small"
                class="mr-1"
              ></v-icon>
              {{
                item.hasSalesHistory
                  ? $t("projections.hasHistory")
                  : $t("projections.noHistory")
              }}
            </v-chip>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn
              color="#ffb500"
              variant="elevated"
              size="small"
              :prepend-icon="mdiChartLineVariant"
              @click="createProjection(item)"
              class="text-white"
            >
              {{ $t("projections.createProjection") }}
            </v-btn>
          </template>

          <template v-slot:no-data>
            <v-alert type="info" variant="tonal" class="ma-4">
              {{ $t("projections.noEligibleCustomers") }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  mdiMagnify,
  mdiChartLine,
  mdiChartLineVariant,
  mdiCheckCircle,
  mdiAlertCircle,
} from "@mdi/js";

export default {
  name: "ProjectionCustomerList",
  data() {
    return {
      search: "",
      mdiMagnify,
      mdiChartLine,
      mdiChartLineVariant,
      mdiCheckCircle,
      mdiAlertCircle,
    };
  },
  computed: {
    ...mapState("projections", ["eligibleCustomers", "loading", "error"]),
    headers() {
      return [
        {
          title: this.$t("projections.customerNumber"),
          key: "number",
          sortable: true,
        },
        {
          title: this.$t("projections.customerName"),
          key: "name",
          sortable: true,
        },
        {
          title: this.$t("projections.salesHistory"),
          key: "hasSalesHistory",
          sortable: true,
        },
        {
          title: this.$t("actions"),
          key: "actions",
          sortable: false,
          align: "center",
        },
      ];
    },
  },
  mounted() {
    this.loadCustomers();
  },
  methods: {
    ...mapActions("projections", ["fetchEligibleCustomers", "selectCustomer"]),
    async loadCustomers() {
      try {
        await this.fetchEligibleCustomers();
      } catch {
        this.$store.dispatch("showSnackbar", {
          message: this.$t("alert.error.generic"),
          color: "error",
        });
      }
    },
    createProjection(customer) {
      this.selectCustomer(customer);
      this.$emit("create-projection", customer);
    },
    clearError() {
      this.$store.commit("projections/setError", null);
    },
  },
};
</script>

<style scoped>
.v-chip {
  font-weight: 500;
}
</style>
